import { useAuth } from "features/auth/hooks/useAuth";
import { Navigate } from "react-router-dom";

export default function HomeRedirect() {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;

  if (!user) return <Navigate to="/auth/login" replace />;

  return <Navigate to="/home" replace />;
}
